// api routes
import axios from 'axios';

import { url } from './endpointURL';

export const API = axios.create({ baseURL: url});


export const isUserRegistered = (user) => API.post('/check_user', user);

export const fetchUser = (email) => API.post('/fetch_user', email);

export const fetchSelectedCamera = (cameraData) => API.post('/fetch_camera', cameraData);

export const addUser = (userData) => API.post('/add_user', userData);

export const businessTokenMapping = (user) => API.post('/business_token_mapping', user);

// Data Exports API has a prefix of /data_exports
export const dataExportsAPI = axios.create({ baseURL: url + '/data_exports', });

export const cloudTransferJobsAPI = axios.create({ baseURL: url + '/data_exports/cloud_transfers', });

export const loggingAPI = axios.create({ baseURL: url + '/logs', });